module.exports = __webpack_public_path__ + "static/media/apache-13 1.fcb9aa72.png";